module.exports = __webpack_public_path__ + "img/logo-white.41242358.svg";